interface DebugInfo {
  environment: string;
  mode: string;
  apiUrl: string;
  loginUrl: string;
  hasWeatherConfig: boolean;
  hasLocationConfig: boolean;
  userAgent: string;
  timestamp: string;
  buildInfo: {
    version: string;
    commit: string;
    branch: string;
    buildTime: string;
  };
}

export function getDebugInfo(): DebugInfo {
  return {
    environment: import.meta.env.MODE,
    mode: import.meta.env.MODE,
    apiUrl: import.meta.env.VITE_API_URL || 'NOT_SET',
    loginUrl: import.meta.env.VITE_LOGIN_URL || 'NOT_SET',
    hasWeatherConfig: !!(import.meta.env.VITE_WEATHER_API_KEY || import.meta.env.VITE_OPENWEATHER_API_KEY),
    hasLocationConfig: !!(import.meta.env.VITE_LOCATION_API_KEY || import.meta.env.VITE_IPAPI_KEY),
    userAgent: navigator.userAgent,
    timestamp: new Date().toISOString(),
    buildInfo: {
      version: import.meta.env.VITE_APP_VERSION || 'unknown',
      commit: import.meta.env.VITE_COMMIT_HASH || 'unknown',
      branch: import.meta.env.VITE_BRANCH || 'unknown',
      buildTime: import.meta.env.VITE_BUILD_TIME || 'unknown'
    }
  };
}

export function logDebugInfo(): void {
  const debugInfo = getDebugInfo();
  
  console.group('🔍 Debug Information');
  console.log('Environment:', debugInfo.environment);
  console.log('Mode:', debugInfo.mode);
  console.log('API URL:', debugInfo.apiUrl);
  console.log('Login URL:', debugInfo.loginUrl);
  console.log('Weather Config:', debugInfo.hasWeatherConfig);
  console.log('Location Config:', debugInfo.hasLocationConfig);
  console.log('User Agent:', debugInfo.userAgent);
  console.log('Timestamp:', debugInfo.timestamp);
  console.log('Build Info:', debugInfo.buildInfo);
  console.groupEnd();
}

export function checkEnvironmentVariables(): void {
  const requiredVars = [
    'VITE_API_URL',
    'VITE_LOGIN_URL'
  ];
  
  const optionalVars = [
    'VITE_WEATHER_API_KEY',
    'VITE_OPENWEATHER_API_KEY',
    'VITE_LOCATION_API_KEY',
    'VITE_IPAPI_KEY'
  ];
  
  console.group('🔧 Environment Variables Check');
  
  console.log('Required Variables:');
  requiredVars.forEach(varName => {
    const value = import.meta.env[varName];
    const status = value ? '✅' : '❌';
    console.log(`${status} ${varName}: ${value || 'NOT_SET'}`);
  });
  
  console.log('\nOptional Variables:');
  optionalVars.forEach(varName => {
    const value = import.meta.env[varName];
    const status = value ? '✅' : '⚠️';
    console.log(`${status} ${varName}: ${value || 'NOT_SET'}`);
  });
  
  console.groupEnd();
}

export function logComponentState(componentName: string, props: Record<string, unknown>, state?: Record<string, unknown>): void {
  console.group(`🎯 ${componentName} State`);
  console.log('Props:', props);
  if (state) {
    console.log('State:', state);
  }
  console.log('Timestamp:', new Date().toISOString());
  console.groupEnd();
}

export function logError(error: Error, context?: string): void {
  console.group('❌ Error Log');
  console.log('Context:', context || 'Unknown');
  console.log('Error:', error.message);
  console.log('Stack:', error.stack);
  console.log('Timestamp:', new Date().toISOString());
  console.groupEnd();
}
